import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty'
import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

type ErrorPanelProps = {
  icon: LucideIcon
  title: string
  description: string
  /** The way out: a retry or a link home. */
  children?: ReactNode
}

/** The one layout of the error pages (#878): icon, title, text and the way out. */
export function ErrorPanel({ icon: Icon, title, description, children }: ErrorPanelProps) {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Icon />
        </EmptyMedia>
        <EmptyTitle>
          <h2>{title}</h2>
        </EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      {children && <EmptyContent>{children}</EmptyContent>}
    </Empty>
  )
}
